import { render } from "./SmallIconTextButton.vue?vue&type=template&id=6e64692a&scoped=true"
import script from "./SmallIconTextButton.vue?vue&type=script&lang=js"
export * from "./SmallIconTextButton.vue?vue&type=script&lang=js"

import "./SmallIconTextButton.vue?vue&type=style&index=0&id=6e64692a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e64692a"]])

export default __exports__